<div [chart]="mosaicStatisticBarChart"></div>
